import { useIntl } from 'react-intl';
import { forwardRef } from '@chakra-ui/react';

import { Table } from '../../Table';
import { type RowProps } from '../../Table/parts';
import { useFees } from '../context';

export type CardPaymentDisputeProps = RowProps;

export const CardPaymentDispute = forwardRef<CardPaymentDisputeProps, 'div'>(
  (props, ref) => {
    const intl = useIntl();
    const { fees, toFixed, toVariable } = useFees();

    const locales = {
      label: intl.formatMessage({
        id: 'subscription.fees_modal.card_payment_dispute.label',
      }),
      value: intl.formatMessage(
        {
          id: 'subscription.fees_modal.card_payment_dispute.value',
        },
        {
          fixed: toFixed(fees.cardPaymentDispute),
          variable: toVariable(fees.cardPaymentDispute),
        },
      ),
    };

    return (
      <Table.Row {...props} ref={ref}>
        <Table.CellText>{locales.label}</Table.CellText>
        <Table.CellAmount>{locales.value}</Table.CellAmount>
      </Table.Row>
    );
  },
);
